import { render, staticRenderFns } from "./HighThroughputDownload.vue?vue&type=template&id=2820e573&scoped=true&"
import script from "./HighThroughputDownload.vue?vue&type=script&lang=js&"
export * from "./HighThroughputDownload.vue?vue&type=script&lang=js&"
import style0 from "./HighThroughputDownload.vue?vue&type=style&index=0&id=2820e573&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2820e573",
  null
  
)

export default component.exports